import styled, { css } from 'styled-components';
import { PropsWithChildren } from 'react';

type Props = {
  externalLink?: String | null | undefined;
  target?: String | undefined;
  onClick?: () => void;
  disabled?: Boolean;
  className?: string;
  type?: string;
};

function Button({
  externalLink,
  target = '_blank',
  onClick,
  disabled,
  children,
  className,
  type
}: PropsWithChildren<Props>) {
  const as = externalLink ? 'a' : type === 'submit' ? 'button' : 'div';
  return (
    <ButtonWrapper
      className={className}
      as={as}
      target={target}
      href={externalLink}
      type={type}
      // @ts-ignore
      onClick={!disabled && !externalLink ? onClick : null}
      disabled={disabled}>
      {children}
    </ButtonWrapper>
  );
}

const ButtonWrapper = styled.button<Props>`
  background: #000;
  color: #fff;
  cursor: pointer;
  padding: 14px 20px;
  font-size: 18px;
  text-decoration: none;
  border-radius: 6px;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 350px;
  font-weight: 500;
  display: flex;
  text-decoration: none;
  ${({ disabled }) =>
    disabled
      ? css`
          background: #ddd;
          pointer-events: none;
        `
      : ''}
`;

export default Button;
